// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import softwareDetailsActions from '../../actions/softwareDetails';
import SoftwareDetails from './SoftwareDetails';
import helpActions from '../../actions/help';
import {isSWSwitchIPM, isPPM} from '../../utils/validate';
import {DEEP_LINK_PARAM_TYPE, getDeepLinkParams} from '../../utils/localStorageDataHandler';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),
        softwareName: get(state, 'softwareDetails.softwareName', ''),
        softwareSuggestions: get(state, 'softwareDetails.softwareList', []),
        systemId: get(state, 'softwareDetails.systemId', ''),
        softwareNameError: get(state, 'softwareDetails.softwareNameError', ''),
        softwareId: get(state, 'softwareDetails.softwareId', ''),
        softwareIdError: get(state, 'softwareDetails.softwareIdError', ''),
        enableSoftwareIdField: get(state, 'softwareDetails.enableSoftwareIdField', false),
        enableContinueButton: get(state, 'softwareDetails.enableContinueButton', false),
        displaySuggestions: get(state, 'softwareDetails.displaySuggestions', false),
        displaySoftwareIdHelpPanel: get(state, 'softwareDetails.displaySoftwareIdHelpPanel', false),
        serviceError: get(state, 'softwareDetails.serviceError', ''),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        softwareDetails: get(state, 'softwareDetails', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        softwareDetailsActions: bindActionCreators(softwareDetailsActions, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class SoftwareDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.setSoftwareName = this.setSoftwareName.bind(this);
        this.setSoftwareId = this.setSoftwareId.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleToggleFieldView = this.handleToggleFieldView.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.selectSoftware = this.selectSoftware.bind(this);
        this.dismissSuggestionDropDown = this.dismissSuggestionDropDown.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.handleUnListedSoftwareClick = this.handleUnListedSoftwareClick.bind(this);
        this.handleFindSoftwareUserID = this.handleFindSoftwareUserID.bind(this);
        this.dismissSidePanel = this.dismissSidePanel.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.prePopulateLocalState = this.prePopulateLocalState.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(false);
    }

    componentDidMount() {
        this.setSoftwareInfoByDeepLinkParams();
    }

    setSoftwareInfoByDeepLinkParams() {
        const ulxParams = getDeepLinkParams(DEEP_LINK_PARAM_TYPE.ulxParams);

        if (ulxParams) {
            const {systemName, systemId} = ulxParams;
            this.chooseSoftware(systemName, systemId);
        } else {
            const pmscParams = getDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams);

            if (pmscParams) {
                const {advertiserAssignedId, systemName, systemId} = pmscParams;
                this.props.softwareDetailsActions.setSoftwareId(advertiserAssignedId);
                if (systemName && systemId) {
                    this.props.appActions.triggerEdapEvent('generic.event', {
                        prefilled: 'true'
                    }, {});
                    this.chooseSoftware(systemName, systemId);
                } else {
                    this.props.softwareDetailsActions.setSoftwareNameError('ipmob.input.field.required');
                    this.props.softwareDetailsActions.enableSoftwareIdField(true);
                }
            }
        }
        this.props.appActions.triggerEdapEvent('generic.event', {
            pmType: this.props.userType
        }, {});
}

    setAdvertiserIdByPmscParams(systemId) {
        const pmscParams = getDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams);

        if (pmscParams && pmscParams.advertiserAssignedId) {
            if (pmscParams.systemId && (systemId !== pmscParams.systemId)) {
                this.props.softwareDetailsActions.setSoftwareId('');
            } else {
                this.props.softwareDetailsActions.setSoftwareId(pmscParams.advertiserAssignedId);
            }
        }
    }

    setSoftwareName(event) {
        event.preventDefault();
        const value = event.target.value;
        this.props.softwareDetailsActions.setEditStatus(true);
        this.props.softwareDetailsActions.setSoftwareName(value);
        this.props.softwareDetailsActions.toggleFieldView('softwareName');
        if (!value) {
            this.props.softwareDetailsActions.dismissSuggestionDropDown();
            this.props.softwareDetailsActions.setEditStatus(false);
        } else if (value.length >= 3) {
            this.props.softwareDetailsActions.getSoftwareSuggestions(value);
        }
        this.props.softwareDetailsActions.toggleContinueButtonView();
    }

    selectSoftware(event) {
        event.preventDefault();
        const softwareName = event.target.name;
        const systemId = event.target.id;
        this.chooseSoftware(softwareName, systemId);
    }

    chooseSoftware(softwareName, systemId) {
        this.props.softwareDetailsActions.setSoftwareName(softwareName);
        this.props.softwareDetailsActions.setSystemId(systemId);
        this.props.softwareDetailsActions.enableSoftwareIdField(true);
        this.setAdvertiserIdByPmscParams(systemId);
        this.props.softwareDetailsActions.toggleContinueButtonView();
    }

    setSoftwareId(event) {
        event.preventDefault();
        this.props.softwareDetailsActions.setSoftwareId(event.target.value);
        this.props.softwareDetailsActions.toggleFieldView('softwareId');
        this.props.softwareDetailsActions.toggleContinueButtonView();
    }

    dismissSuggestionDropDown() {
        this.props.softwareDetailsActions.dismissSuggestionDropDown();
    }

    dismissSidePanel() {
        this.props.softwareDetailsActions.showSoftwareIdHelpPanel(false);
    }

    handleFormSubmit(event) {
        event.preventDefault();
        const softwareDetails = {
            softwareId: this.props.softwareId,
            systemId: this.props.systemId,
            softwareName: this.props.softwareName
        };
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        if (isSWSwitchIPM(this.props.userType) || isPPM(this.props.userType)) {
            this.props.softwareDetailsActions.validateSoftwareDetails(softwareDetails);
        } else {
            this.props.softwareDetailsActions.submitSoftwareDetails(softwareDetails);
        }
        this.props.appActions.enableLoadOverLay(true);
    }

    triggerEdapEventOnFocus(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Focus on ${event.target.name}`,
            highfrequency: 'true'
        }, {});
    }

    handleUnListedSoftwareClick() {
        this.props.helpActions.toggleHelpModal(true, 'helpModal', 'unlistedSoftware');
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'My Software not listed'
        }, {});
    }

    handleFindSoftwareUserID() {
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Where can I find software id'
        }, {});
        window.scrollTo(0, 0);
        this.props.softwareDetailsActions.showSoftwareIdHelpPanel(true);
    }

    handleToggleFieldView(event) {
        event.preventDefault();
        if (this.props.systemId) {
            this.props.softwareDetailsActions.dismissSuggestionDropDown();
        } else if (!this.props.softwareName) {
            this.props.softwareDetailsActions.setSoftwareNameError('ipmob.input.field.required');
        }
    }

    handleAlertDismiss() {
        this.props.softwareDetailsActions.dismissAlertBox();
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Software Details Page');
    }

    handleSaveAndFinishOnClick() {
        const stateData = {...this.props.softwareDetails};
        delete stateData.softwareId;
        delete stateData.serviceError;
        this.props.appActions.saveComponentState('softwareDetails', stateData);
        this.props.appActions.showSaveAndFinishModal(true);
    }

    prePopulateLocalState() {
        this.props.softwareDetailsActions.prePopulateLocalState(this.props.publicUuid);
    }

    handleSaveModalClose() {
        this.props.appActions.showSaveAndFinishModal(false);
    }

    render() {
        return (
            <SoftwareDetails
                translations={this.props.translations}
                softwareNameValue={this.props.softwareName}
                softwareSuggestions={this.props.softwareSuggestions}
                softwareNameError={this.props.softwareNameError}
                handleSoftwareNameChange={this.setSoftwareName}
                softwareIdValue={this.props.softwareId}
                softwareIdError={this.props.softwareIdError}
                handleSoftwareIdChange={this.setSoftwareId}
                enableSoftwareIdField={this.props.enableSoftwareIdField}
                enableContinueButton={this.props.enableContinueButton}
                handleContinueButtonClick={this.handleFormSubmit}
                handleToggleFieldView={this.handleToggleFieldView}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}
                displaySuggestions={this.props.displaySuggestions}
                displaySoftwareIdHelpPanel={this.props.displaySoftwareIdHelpPanel}
                handleSoftwareSelect={this.selectSoftware}
                handleDropDownDismiss={this.dismissSuggestionDropDown}
                handleUnListedSoftwareClick={this.handleUnListedSoftwareClick}
                handleFindSoftwareUserID={this.handleFindSoftwareUserID}
                dismissSidePanel={this.dismissSidePanel}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                prePopulateLocalState={this.prePopulateLocalState}
                isSaveModalOpen={this.props.isSaveModalOpen}
                handleSaveModalClose={this.handleSaveModalClose}
            />
        );
    }
}

SoftwareDetailsContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string, // eslint-disable-line react/forbid-prop-types
    softwareName: PropTypes.string,
    softwareNameError: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    softwareId: PropTypes.string,
    softwareIdError: PropTypes.string,
    enableSoftwareIdField: PropTypes.bool,
    enableContinueButton: PropTypes.bool,
    displaySuggestions: PropTypes.bool,
    serviceError: PropTypes.string,
    softwareDetails: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

SoftwareDetailsContainer.defaultProps = {
    publicUuid: '-1',
    softwareName: '',
    softwareNameError: '',
    softwareId: '',
    softwareIdError: '',
    enableSoftwareIdField: false,
    enableContinueButton: false,
    displaySuggestions: false,
    serviceError: '',
    softwareDetails: {}
};

export default SoftwareDetailsContainer;
